var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceFailureLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 119.437,
    viewBox: "0 0 120 119.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M41.944-869.944l10.282,10.282H46.592v61.972H98.423L28-868.113,35.887-876,147.437-764.451l-7.887,7.887L109.69-786.422H102.93v11.268H114.2v11.268H69.127v-11.268H80.394v-11.268h-33.8a10.85,10.85,0,0,1-7.958-3.31,10.85,10.85,0,0,1-3.31-7.958v-61.972q0-5.211,3.31-7.747Zm98.732,82.676L130.254-797.69h6.479v-61.972H68.282L57.014-870.93h79.718a10.848,10.848,0,0,1,7.958,3.31,10.85,10.85,0,0,1,3.31,7.958v61.972a10.751,10.751,0,0,1-2.042,6.479A10.753,10.753,0,0,1,140.676-787.268ZM99.268-828.676ZM72.507-823.606Z",
    transform: "translate(-28 876)",
    fill: "#ed1b24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceFailureLarge);
export default __webpack_public_path__ + "static/media/deviceFailureLarge.fa6f416f0c59a8ea4632072b62be52ce.svg";
export { ForwardRef as ReactComponent };